(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-new"]) return;
  try {
    
(function () {
  // The per-option selects share the .variant-selector class so they inherit its
  // styling. Anywhere the code means "the hidden select holding every variant",
  // it must exclude them.
  var COMBINED = ".variant-selector:not(.option-selector)";

  function getLabels(section) {
    return {
      oos:   (section.querySelector("[data-oos-label]")?.textContent || "(Ausverkauft)").trim(),
      add:   (section.querySelector("[data-label-add]")?.textContent || "Hinzufügen").trim(),
      added: (section.querySelector("[data-label-added]")?.textContent || "Hinzugefügt").trim(),
      view:  (section.querySelector("[data-label-view]")?.textContent || "Produkt ansehen").trim(),
    };
  }

  function buildVariantUrl(productUrl, variantId) {
    if (!productUrl) return "#";
    var joiner = productUrl.indexOf("?") === -1 ? "?" : "&";
    return productUrl + joiner + "variant=" + variantId;
  }

  // ===== Per-option selects (products with more than one option) =====

  function optionSelectorsFor(productItem) {
    var selects = Array.prototype.slice.call(productItem.querySelectorAll(".option-selector"));
    selects.sort(function (a, b) {
      return parseInt(a.dataset.optionIndex, 10) - parseInt(b.dataset.optionIndex, 10);
    });
    return selects;
  }

  // Exact match: every option select's value matches the variant's option values
  function findExactVariantOption(combined, values) {
    for (var i = 0; i < combined.options.length; i++) {
      var opt = combined.options[i];
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if ((opt.dataset["option" + (j + 1)] || "") !== values[j]) {
          match = false;
          break;
        }
      }
      if (match) return opt;
    }
    return null;
  }

  // Fallback: keep the option the shopper just changed, prefer an available variant
  function findVariantOptionByValue(combined, optionIndex, value) {
    var firstMatch = null;
    for (var i = 0; i < combined.options.length; i++) {
      var opt = combined.options[i];
      if ((opt.dataset["option" + optionIndex] || "") !== value) continue;
      if (!firstMatch) firstMatch = opt;
      if (opt.dataset.available === "true") return opt;
    }
    return firstMatch;
  }

  function syncOptionSelectsToVariant(selects, variantOption) {
    selects.forEach(function (select) {
      var value = variantOption.dataset["option" + select.dataset.optionIndex] || "";
      if (value && select.value !== value) select.value = value;
    });
  }

  // Resolve the option selects to a variant and hand it to the existing logic
  function resolveOptionGroup(section, productItem, changedSelect) {
    var combined = productItem.querySelector(COMBINED);
    if (!combined) return;

    var selects = optionSelectorsFor(productItem);
    if (!selects.length) return;

    var values = selects.map(function (select) { return select.value; });
    var variantOption = findExactVariantOption(combined, values);

    if (!variantOption && changedSelect) {
      variantOption = findVariantOptionByValue(combined, changedSelect.dataset.optionIndex, changedSelect.value);
    }
    if (!variantOption) {
      variantOption = combined.options[combined.selectedIndex];
    }
    if (!variantOption) return;

    syncOptionSelectsToVariant(selects, variantOption);
    combined.value = variantOption.value;
    applyVariantState(section, combined);
  }

  function syncAllOptionGroups(section) {
    section.querySelectorAll(".custom-product-item").forEach(function (productItem) {
      if (!productItem.querySelector(".option-selector")) return;
      resolveOptionGroup(section, productItem, null);
    });
  }

  // An option value is sold out only when no variant carrying it is available
  function applyOosOptionValueLabels(section) {
    var labels = getLabels(section);

    section.querySelectorAll(".custom-product-item").forEach(function (productItem) {
      var combined = productItem.querySelector(COMBINED);
      var selects = optionSelectorsFor(productItem);
      if (!combined || !selects.length) return;

      selects.forEach(function (select) {
        var optionIndex = select.dataset.optionIndex;

        Array.prototype.forEach.call(select.options, function (opt) {
          var baseText = opt.dataset.optionValue || opt.value;
          var available = false;

          for (var i = 0; i < combined.options.length; i++) {
            var variantOption = combined.options[i];
            if ((variantOption.dataset["option" + optionIndex] || "") !== opt.value) continue;
            if (variantOption.dataset.available === "true") {
              available = true;
              break;
            }
          }

          opt.textContent = available ? baseText : baseText + " " + labels.oos;
        });
      });
    });
  }

  function setupScrollRestore(savedScrollY) {
    var onClose = function () {
      setTimeout(function () {
        window.scrollTo({ top: savedScrollY, left: 0, behavior: "instant" });
      }, 50);
    };
    document.addEventListener("rebuy:cart.hide", onClose, { once: true });
    document.addEventListener("rebuy:smartcart.hide", onClose, { once: true });
    document.addEventListener("rebuy:modal.hide", onClose, { once: true });
  }

  function applyOosOptionLabels(section) {
    var labels = getLabels(section);
    section.querySelectorAll(COMBINED + " option").forEach(function (opt) {
      var baseTitle = opt.dataset.variantTitle || opt.textContent.trim().replace(/\s*\([^)]*\)\s*$/, "");
      if (opt.dataset.available === "false") {
        opt.textContent = baseTitle + " " + labels.oos;
      } else {
        opt.textContent = baseTitle;
      }
    });
  }

  function applyVariantState(section, select) {
    var labels = getLabels(section);
    var productId = select.dataset.productId;
    var selected = select.options[select.selectedIndex];
    if (!selected) return;

    var fallbackImage = select.dataset.fallbackImage;
    var variantId = selected.value;

    var productItem = section.querySelector('.custom-product-item[data-product-id="' + productId + '"]');
    if (!productItem) return;

    var productUrl = productItem.dataset.productUrl || "";

    var priceEl = section.querySelector("#product-price-" + productId);
    var compareEl = section.querySelector("#product-compare-price-" + productId);
    var imageEl = section.querySelector("#product-image-" + productId);
    var outOfStockEl = productItem.querySelector(".out-of-stock");
    var productLinkEl = productItem.querySelector(".product-link");
    var addBtn = productItem.querySelector(".add-to-cart, .view-product");

    if (productLinkEl) {
      productLinkEl.setAttribute("href", buildVariantUrl(productUrl, variantId));
    }

    if (priceEl && selected.dataset.price) {
      priceEl.innerHTML = selected.dataset.price;
    }

    if (compareEl) {
      if (selected.dataset.comparePrice) {
        compareEl.innerHTML = selected.dataset.comparePrice;
        compareEl.style.display = "";
      } else {
        compareEl.style.display = "none";
      }
    }

    if (imageEl) {
      imageEl.src = selected.dataset.image || fallbackImage;
    }

    if (addBtn) {
      var isAvailable = selected.dataset.available === "true";
      var labelEl = addBtn.querySelector(".button-label");
      var iconEl = addBtn.querySelector(".custom-button-icon");
      var variantUrl = buildVariantUrl(productUrl, variantId);

      addBtn.dataset.variantId = variantId;
      addBtn.dataset.productUrl = productUrl;

      addBtn.classList.remove("added", "loading");
      addBtn.disabled = false;
      addBtn.style.cursor = "";

      if (isAvailable) {
        addBtn.classList.remove("view-product");
        addBtn.classList.add("add-to-cart");
        if (labelEl) labelEl.textContent = labels.add;
        if (iconEl) iconEl.style.display = "";
        addBtn.removeAttribute("href");
        if (outOfStockEl) outOfStockEl.classList.add("hide");
      } else {
        addBtn.classList.remove("add-to-cart");
        addBtn.classList.add("view-product");
        if (labelEl) labelEl.textContent = labels.view;
        if (iconEl) iconEl.style.display = "";
        if (addBtn.tagName === "A") {
          addBtn.setAttribute("href", variantUrl);
        }
        if (outOfStockEl) outOfStockEl.classList.remove("hide");
      }
    }
  }

  function syncAllVariants(section) {
    section.querySelectorAll(COMBINED).forEach(function (select) {
      applyVariantState(section, select);
    });
  }

  function bindHandlers(section) {
    // Variant selector (single-option products bind here; multi-option
    // products are driven by the .option-selector handlers below)
    section.querySelectorAll(COMBINED).forEach(function (select) {
      if (select.dataset.bound === "1") return;
      select.dataset.bound = "1";

      ["click", "mousedown", "touchstart"].forEach(function (evt) {
        select.addEventListener(evt, function (e) { e.stopPropagation(); });
      });

      select.addEventListener("change", function (e) {
        e.stopPropagation();
        applyVariantState(section, select);
      });
    });

    // Per-option selects
    section.querySelectorAll(".option-selector").forEach(function (select) {
      if (select.dataset.bound === "1") return;
      select.dataset.bound = "1";

      ["click", "mousedown", "touchstart"].forEach(function (evt) {
        select.addEventListener(evt, function (e) { e.stopPropagation(); });
      });

      select.addEventListener("change", function (e) {
        e.stopPropagation();
        var productItem = select.closest(".custom-product-item");
        if (productItem) resolveOptionGroup(section, productItem, select);
      });
    });

    // Buttons
    section.querySelectorAll(".custom-product-item .custom-button").forEach(function (btn) {
      if (btn.dataset.bound === "1") return;
      btn.dataset.bound = "1";

      btn.addEventListener("click", function (e) {
        // View-product mode → navigate to product page
        if (btn.classList.contains("view-product")) {
          e.preventDefault();
          e.stopPropagation();
          var url = btn.dataset.variantId
            ? buildVariantUrl(btn.dataset.productUrl, btn.dataset.variantId)
            : btn.dataset.productUrl;
          if (url) window.location.href = url;
          return;
        }

        // Already-added → navigate to product page
        if (btn.classList.contains("added")) {
          e.preventDefault();
          e.stopPropagation();
          var url2 = btn.dataset.variantId
            ? buildVariantUrl(btn.dataset.productUrl, btn.dataset.variantId)
            : btn.dataset.productUrl;
          if (url2) window.location.href = url2;
          return;
        }

        // Add-to-cart flow
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains("loading")) return;

        // Defensive sync: trust the <select> over the button's data-variant-id
        var productItem = btn.closest(".custom-product-item");
        var productSelect = productItem ? productItem.querySelector(COMBINED) : null;

        if (productSelect) {
          if (productItem.querySelector(".option-selector")) {
            resolveOptionGroup(section, productItem, null);
          } else {
            applyVariantState(section, productSelect);
          }
          if (btn.classList.contains("view-product")) {
            var url3 = btn.dataset.variantId
              ? buildVariantUrl(btn.dataset.productUrl, btn.dataset.variantId)
              : btn.dataset.productUrl;
            if (url3) window.location.href = url3;
            return;
          }
        }

        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var labelEl = btn.querySelector(".button-label");
        var iconEl = btn.querySelector(".custom-button-icon");
        var labels = getLabels(section);
        var savedScrollY = window.scrollY || window.pageYOffset;

        btn.disabled = true;
        btn.classList.add("loading");
        if (labelEl) labelEl.textContent = "...";
        if (iconEl) iconEl.style.display = "none";

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error(err.description || "Add to cart failed");
              });
            }
            return res.json();
          })
          .then(function () {
            var freshLabels = getLabels(section);
            btn.classList.remove("loading");
            btn.classList.add("added");
            if (labelEl) labelEl.textContent = freshLabels.added;
            if (iconEl) iconEl.style.display = "none";
            btn.disabled = false;
            btn.style.cursor = "pointer";

            // Revert to "Hinzufügen" after 3 seconds
            setTimeout(function () {
              // Skip if the button changed state in the meantime
              // (e.g. variant switch turned it into view-product)
              if (!btn.classList.contains("added")) return;
              var revertLabels = getLabels(section);
              btn.classList.remove("added");
              if (labelEl) labelEl.textContent = revertLabels.add;
              if (iconEl) iconEl.style.display = "";
              btn.style.cursor = "";
            }, 3000);

            return fetch("/cart.js")
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll("[data-cart-count], .cart-count, .cart-item-count").forEach(function (el) {
                  el.textContent = cart.item_count;
                });
                document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
                setupScrollRestore(savedScrollY);
              });
          })
          .catch(function (err) {
            console.error("Add to cart error:", err);
            var freshLabels = getLabels(section);
            btn.classList.remove("loading");
            btn.disabled = false;
            if (labelEl) labelEl.textContent = freshLabels.add;
            if (iconEl) iconEl.style.display = "";
          });
      });
    });
  }

  function runInitialSync(section) {
    applyOosOptionLabels(section);
    applyOosOptionValueLabels(section);
    syncAllVariants(section);
    syncAllOptionGroups(section);
    // One additional pass after 800ms to catch T Lab's translation,
    // plus Chrome's form-state restoration
    setTimeout(function () {
      applyOosOptionLabels(section);
      applyOosOptionValueLabels(section);
      syncAllVariants(section);
      syncAllOptionGroups(section);
    }, 800);
  }

  function setupSection(section) {
    if (section.dataset.ccInit === "1") return;
    section.dataset.ccInit = "1";
    bindHandlers(section);
    runInitialSync(section);
  }

  function initAll() {
    document.querySelectorAll(".custom-collection-section").forEach(function (section) {
      // Defer init until section is near viewport — this section is typically
      // below the fold, no reason to wire up handlers on initial page load
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              observer.disconnect();
              setupSection(section);
            }
          });
        }, { rootMargin: "550px 0px" });
        io.observe(section);
      } else {
        setupSection(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // bfcache / back-button restoration
  window.addEventListener("pageshow", function () {
    document.querySelectorAll(".custom-collection-section").forEach(function (section) {
      if (section.dataset.ccInit === "1") {
        applyOosOptionLabels(section);
        applyOosOptionValueLabels(section);
        syncAllVariants(section);
        syncAllOptionGroups(section);
      }
    });
  });

  // Theme editor re-init
  document.addEventListener("shopify:section:load", function (e) {
    var sec = e.target.querySelector(".custom-collection-section");
    if (sec) setupSection(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_ATTEMPTS = 100; // ~5s at 50ms intervals before giving up

  function doInit() {
    if (typeof Swiper === 'undefined') return false;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-banner-swiper]').forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;

      new Swiper(el, {
        loop: true,
        autoplay: reducedMotion ? false : {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev')
        }
      });
    });
    return true;
  }

  function initWithRetry(attempts) {
    attempts = attempts || 0;
    if (doInit()) {
      // After Swiper is up, gently prefetch slide 2's image so the first
      // auto-rotate is smooth. Done HERE (not in HTML) so it doesn't
      // compete with the LCP image for bandwidth.
      prefetchSlide2();
      return;
    }
    if (attempts >= MAX_ATTEMPTS) {
      // Swiper truly failed to load — first slide is already visible
      // via the inline critical CSS, so the user still sees something
      document.querySelectorAll('[data-banner-swiper]').forEach(function (el) {
        el.classList.add('swiper-load-failed');
      });
      return;
    }
    setTimeout(function () { initWithRetry(attempts + 1); }, 50);
  }

  function prefetchSlide2() {
    var slides = document.querySelectorAll('[data-banner-swiper] .swiper-slide');
    if (slides.length < 2) return;
    var img = slides[1].querySelector('img');
    if (!img || !img.src) return;
    var preloader = new Image();
    preloader.src = img.currentSrc || img.src;
  }

  // ===== Defer Swiper init until AFTER LCP fires =====
  // The first slide is already visible from the inline critical CSS, so
  // Swiper only needs to attach navigation, autoplay, and swipe behavior.
  // Doing this after `load` event means the LCP measurement completes
  // without Swiper's JS execution counted against it.
  function deferredInit() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { initWithRetry(); }, { timeout: 2000 });
    } else {
      setTimeout(function () { initWithRetry(); }, 100);
    }
  }

  if (document.readyState === 'complete') {
    deferredInit();
  } else {
    window.addEventListener('load', deferredInit, { once: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-calendar-section"]) return;
  try {
    
(function () {
  var MAX_SWIPER_ATTEMPTS = 100;

  function initSwiperWithRetry(container, attempts) {
    attempts = attempts || 0;
    if (typeof Swiper === 'undefined') {
      if (attempts >= MAX_SWIPER_ATTEMPTS) {
        console.warn('[release-calendar] Swiper failed to load');
        return;
      }
      return setTimeout(function () {
        initSwiperWithRetry(container, attempts + 1);
      }, 50);
    }
    initSwiper(container);
  }

  function initSwiper(container) {
    var swiperEl = container.querySelector('.mySwiper2');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      }
    });
  }

  function setupSection(container) {
    if (container.dataset.calendarInit === '1') return;
    container.dataset.calendarInit = '1';

    var mql = window.matchMedia('(max-width: 768px)');

    function maybeInit() {
      if (!mql.matches) return; // Desktop: nothing to do, .special-box-mobile is hidden

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              observer.disconnect();
              initSwiperWithRetry(container);
            }
          });
        }, { rootMargin: '550px 0px' });
        io.observe(container);
      } else {
        initSwiperWithRetry(container);
      }
    }

    maybeInit();

    // Re-evaluate if viewport crosses the mobile breakpoint
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', function (e) {
        if (e.matches) maybeInit();
      });
    } else if (typeof mql.addListener === 'function') {
      // Safari < 14
      mql.addListener(function (e) {
        if (e.matches) maybeInit();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.container-calendar').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.container-calendar');
    if (sec) setupSection(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bands-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_SWIPER_ATTEMPTS = 100;

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getPreviousMonthLabel() {
    var now = new Date();
    var prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    var mm = String(prev.getMonth() + 1).padStart(2, '0');
    return mm + ' / ' + prev.getFullYear();
  }

  function getCollectionLookup() {
    var lookup = {};
    var script = document.getElementById('all-genres-json');
    if (!script) return lookup;
    try {
      var data = JSON.parse(script.textContent);
      (data.items || []).forEach(function (item) {
        if (item && item.name) {
          lookup[String(item.name).trim().toLowerCase()] = item.collection || '';
        }
      });
    } catch (e) {
      console.warn('[top-brands-section] all-genres-json parse failed:', e);
    }
    return lookup;
  }

  function buildSlideHTML(band, periodLabel) {
    return ''
      + '<div class="swiper-slide">'
      +   '<div class="swiper-slide-main">'
      +     '<div class="img_container"><img style="background-color:#9CAE87" src="' + escapeHtml(band.thumbnail) + '" '
      +          'width="300" height="300" alt="' + escapeHtml(band.name) + '" loading="lazy"></div>'
      +     '<div class="inner-details">'
      +       '<h3>' + escapeHtml(band.name) + '</h3>'
      +       '<div class="inner-details-1">'
      +         '<div>'
      +           '<img src="https://cdn.shopify.com/s/files/1/0469/3927/5428/files/trending.svg?v=1738754140" width="14" height="14" alt="">'
      +           '<h3>#' + escapeHtml(band.position) + '</h3>'
      +         '</div>'
      +         '<div>'
      +           '<img src="https://cdn.shopify.com/s/files/1/0469/3927/5428/files/month.svg?v=1742981540" width="16" height="16" alt="">'
      +           '<h3>' + escapeHtml(periodLabel) + '</h3>'
      +         '</div>'
      +       '</div>'
      +       '<a href="' + escapeHtml(band.products_url) + '" '
      +          'class="ttb-button">Produkte ansehen</a>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  function initSwiperWithRetry(container, attempts) {
    attempts = attempts || 0;
    if (typeof Swiper === 'undefined') {
      if (attempts >= MAX_SWIPER_ATTEMPTS) {
        console.warn('[top-brands-section] Swiper failed to load');
        return;
      }
      return setTimeout(function () {
        initSwiperWithRetry(container, attempts + 1);
      }, 50);
    }
    initSwiper(container);
  }

  function initSwiper(container) {
    var swiperEl = container.querySelector('.top-bands-swiper');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    var prevBtn = container.querySelector('.custom-swiper-prev');
    var nextBtn = container.querySelector('.custom-swiper-next');

    function toggleNavigation(swiper) {
      var totalSlides = swiper.slides.length;
      var slidesPerView = swiper.params.slidesPerView;
      if (typeof slidesPerView !== 'number') slidesPerView = 1;
      // If all slides fit at once, hide navigation. Use Math.ceil so
      // fractional slidesPerView (e.g. 1.15) doesn't disable nav too early.
      if (totalSlides <= Math.ceil(slidesPerView)) swiper.navigation.disable();
      else swiper.navigation.enable();
    }

    function updateArrowOpacity(swiper) {
      if (!prevBtn || !nextBtn) return;
      if (swiper.realIndex === 0) prevBtn.classList.add('custom-swiper-disabled');
      else prevBtn.classList.remove('custom-swiper-disabled');

      var slidesPerView = swiper.params.slidesPerView;
      if (typeof slidesPerView !== 'number') slidesPerView = 1;
      if (swiper.realIndex >= swiper.slides.length - slidesPerView) {
        nextBtn.classList.add('custom-swiper-disabled');
      } else {
        nextBtn.classList.remove('custom-swiper-disabled');
      }
    }

    new Swiper(swiperEl, {
      // Mobile: show 1.15 slides so the next card peeks in.
      // This is a strong visual hint that the section is swipeable.
      slidesPerView: 1.15,
      spaceBetween: 16,
      breakpoints: {
        480:  { slidesPerView: 1.3, spaceBetween: 20 },
        768:  { slidesPerView: 3,   spaceBetween: 30 },
        1024: { slidesPerView: 4,   spaceBetween: 30 }
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      on: {
        init:        function () { updateArrowOpacity(this); toggleNavigation(this); },
        slideChange: function () { updateArrowOpacity(this); toggleNavigation(this); },
        resize:      function () { toggleNavigation(this); }
      }
    });

    if (prevBtn) prevBtn.hidden = false;
    if (nextBtn) nextBtn.hidden = false;
  }

  function renderDynamic(container, payload) {
    var mount = container.querySelector('.ttb-dynamic-mount');
    var periodLabel = payload.period || getPreviousMonthLabel();
    var items = (payload.bands || []).slice(0, 4);

    if (!items.length) {
      showFallback(container);
      return;
    }

    var collections = getCollectionLookup();

    var slides = items.map(function (b, i) {
      var name = b.display_name || b.name || '';
      var key = name.trim().toLowerCase();
      var collection = collections[key];

      var productsUrl;
      if (collection) {
        if (collection.charAt(0) === '/' || /^https?:\/\//i.test(collection)) {
          productsUrl = collection;
        } else {
          productsUrl = '/collections/' + collection;
        }
      } else {
        console.warn('[top-brands-section] No collection found in all-genres-json for band:', name);
        productsUrl = '#';
      }

      return buildSlideHTML({
        name:         name,
        thumbnail:    b.thumbnail,
        position:     b.position != null ? b.position : (i + 1),
        products_url: productsUrl
      }, periodLabel);
    }).join('');

    mount.innerHTML = ''
      + '<div class="swiper top-bands-swiper">'
      +   '<div class="swiper-wrapper">' + slides + '</div>'
      +   '<div class="swiper-pagination"></div>'
      + '</div>';

    initSwiperWithRetry(container);
  }

  function showFallback(container) {
    var mount = container.querySelector('.ttb-dynamic-mount');
    var fallbackTpl = container.querySelector('.ttb-fallback-template');

    mount.innerHTML = '';
    if (fallbackTpl && fallbackTpl.content && fallbackTpl.content.childElementCount > 0) {
      mount.appendChild(fallbackTpl.content.cloneNode(true));
      initSwiperWithRetry(container);
    } else {
      container.style.display = 'none';
    }
  }

  function fetchAndRender(container) {
    var endpoint = container.dataset.rankingsEndpoint;

    if (!endpoint) {
      showFallback(container);
      return;
    }

    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timeoutId = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);

    fetch(endpoint, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      signal: ctrl ? ctrl.signal : undefined,
      cache: 'default'
    })
      .then(function (res) {
        clearTimeout(timeoutId);
        if (!res.ok) throw new Error('Bad status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        renderDynamic(container, data);
      })
      .catch(function (err) {
        console.warn('[top-brands-section] Falling back to manual blocks:', err);
        showFallback(container);
      });
  }

  function setupSection(container) {
    if (container.dataset.ttbInitialized === '1') return;
    container.dataset.ttbInitialized = '1';

    // Defer the fetch until the section is near the viewport.
    // This frees up bandwidth for the LCP image on initial load.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            fetchAndRender(container);
          }
        });
      }, { rootMargin: '550px 0px' });
      io.observe(container);
    } else {
      // No IntersectionObserver support — fetch immediately
      fetchAndRender(container);
    }
  }

  function initAll() {
    document.querySelectorAll('.top-trending-bands-container').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize when section is added/edited in theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.top-trending-bands-container');
    if (sec) setupSection(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-nolae-section"]) return;
  try {
    
(function () {
  var MAX_SWIPER_ATTEMPTS = 100;

  function initSwiperWithRetry(container, attempts) {
    attempts = attempts || 0;
    if (typeof Swiper === 'undefined') {
      if (attempts >= MAX_SWIPER_ATTEMPTS) {
        console.warn('[why-nolae-section] Swiper failed to load');
        return;
      }
      return setTimeout(function () {
        initSwiperWithRetry(container, attempts + 1);
      }, 50);
    }
    initSwiper(container);
  }

  function initSwiper(container) {
    var swiperEl = container.querySelector('.mySwiper-nolae');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      breakpoints: {
        768: { slidesPerView: 3 }
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      }
    });
  }

  function setupSection(container) {
    if (container.dataset.whyNolaeInit === '1') return;
    container.dataset.whyNolaeInit = '1';

    // Section is below the fold; defer init until it's near viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            initSwiperWithRetry(container);
          }
        });
      }, { rootMargin: '550px 0px' });
      io.observe(container);
    } else {
      initSwiperWithRetry(container);
    }
  }

  function initAll() {
    document.querySelectorAll('.container-why-nolae').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when section is added/edited in theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('.container-why-nolae');
    if (sec) setupSection(sec);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
